import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StatsSettingsProvider } from './context/Context';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <StatsSettingsProvider>
        <App />
      </StatsSettingsProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
